import React from 'react';
// import Image from 'next/image';
import { cn } from '@/shared/utils/shadcn';
import Link from 'next/link';

const SuccessCasesItem = ({
  tag,
  // address,
  title,
  link,
  image,
  isSelected = false,
  className,
}: {
  tag: string;
  address: string;
  title: string;
  link: string;
  image: string;
  isSelected?: boolean;
  className?: string;
}) => {
  return (
    <Link
      href={link}
      className={cn('w-[18.564vw] cursor-pointer', className)}
      // onClick={() => {
      //   if (link) {
      //     if (link.startsWith('http') || link.startsWith('https')) {
      //       window.open(link, '_blank');
      //     } else {
      //       window.open(`${process.env.NEXT_PUBLIC_WEBSITE}${link}`, '_blank');
      //     }
      //   }
      // }}
    >
      <div
        style={{ backgroundImage: `url(${image})` }}
        className="relative mb-[1.872vw] h-[26vw] w-[18.564vw] bg-slate-600 bg-cover bg-center bg-no-repeat shadow-sm"
      >
        <div
          style={{ boxShadow: '-1px 7px 7px 0px rgba(42,42,42,0.17)' }}
          className={`absolute bottom-[-0.728vw] right-[0.676vw] rounded-[10px] px-[0.936vw] py-[0.728vw] text-[0.832vw] font-normal leading-[0.832vw] ${
            isSelected ? 'bg-[#ED8000] text-white' : 'bg-white text-[#111111]'
          }`}
        >
          {tag}
        </div>
      </div>
      {/* <div className="mb-[1.04vw] flex w-full flex-row items-center justify-start">
        <Image
          src={'/images/home/positioning.png'}
          width={14}
          height={20}
          className="mr-[0.416vw] h-auto w-[0.728vw]"
          alt="positioning"
        />
        <div className="text-[0.832vw] font-normal leading-[0.832vw] text-[#333333]">{address}</div>
      </div> */}
      <div className="w-[18.564vw] text-[0.936vw] font-normal leading-[1.872vw] text-[#111111]">{title}</div>
    </Link>
  );
};

export default SuccessCasesItem;
